import { useState } from "react";
import RequestBreadcrumb from "../../common/RequestBreadcrumb";
import BasicDetailsCard from "./common/BasicDetailsCard";
import SimpleSpinner from "../../loader";
import Dashboard from "../../../dashboard/Dashboard";

const OrganizationOverview = () => {
  const [loading, setLoading] = useState(false)

  return (
    <div className="basic_details">
      <RequestBreadcrumb
        firstName={"Dashboard"}
        link={"/"}
        lastName={"My Organization"}
        currentStep={"Overview"}
      />
      {loading ? (
        <SimpleSpinner />
      ) : (
        <div className="OrganizationOverview_container">
          <BasicDetailsCard />
          <Dashboard showDashbordName={false} />
        </div>
      )}
    </div>
  );
};

export default OrganizationOverview;
